import React from 'react';
import { Container, Button, Modal } from 'react-bootstrap';
import { getTraderDisplayName, Trader } from './trader';
import ValidationError from 'common/validationError';

export type DeleteTraderProps = {
	trader: any;
	showDeleteModal: boolean;
	handleDeleteModalCancel: () => void;
	handleDeleteSubmit: (trader: Trader) => Promise<any>;
};

class DeleteTraderModalState {
	trader: Trader;
	errors: string[] = [];
}

export default class DeleteTraderModal extends React.Component<DeleteTraderProps, DeleteTraderModalState> {
	constructor(props: DeleteTraderProps) {
		super(props);

		this.state = { ...new DeleteTraderModalState(), trader: props.trader };
	}

	async handleDeleteSubmit() {
		try {
			await this.props.handleDeleteSubmit(this.state.trader);
		} catch (err) {
			this.setState({ errors: (err as ValidationError).errors });
		}
	}

	handleAbort() {
		this.props.handleDeleteModalCancel();
	}

	render() {
		return (
			<Modal show={this.props.showDeleteModal} onHide={() => this.handleAbort()} centered backdrop="static">
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="fa fa-exclamation-triangle" style={{ color: 'red' }} /> Delete{' '}
						{getTraderDisplayName(this.state.trader)}?
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Container>
						<div>
							Deleting this trader will remove them entirely from the platform, and is irreversible. Are
							you sure you want to delete this trader?
						</div>
					</Container>
				</Modal.Body>
				<Modal.Footer className="align center">
					<div className="pull-right mt-3">
						<Button variant="secondary" className="ml-2" onClick={() => this.handleAbort()}>
							No, Go Back
						</Button>&nbsp;
						<Button variant="danger" onClick={() => this.handleDeleteSubmit()}>
							Yes, Delete
						</Button>
					</div>
				</Modal.Footer>
			</Modal>
		);
	}
}
